import { Injectable, isDevMode } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from './toaster/toaster.service';
import { Constants } from 'src/app/core/constants';
import { SpinnerService } from './spinner.service';
import 'rxjs/add/operator/finally';
import { Router } from '@angular/router';
import { AppSettings } from '../app.settings';
import { BasePage } from '../core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { LocalstorageService } from './localstorage.service';

@Injectable({
    providedIn: 'root',
})
export class HttpInterceptorService extends BasePage implements HttpInterceptor {
    // headers = new HttpHeaders({
    //     'Content-Type': 'application/json',
    // });

    private callCount: number = 0;
    constructor(
        private _router: Router,
        public appSettings: AppSettings,
        public toastService: ToastService,
        private spinnerService: SpinnerService,
        localstorageService: LocalstorageService,
        logger: NGXLogger
        ) {
            super(localstorageService, logger, appSettings);
    }
    // setHeaders(headers: any) {
    //     this.headers = headers;
    // }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.callCount++;
        if (this.callCount === 1 && !req.url.includes('silentquery')) {
            this.spinnerService.show();
        }

        let reqClone = req.clone();
        reqClone = this.setAccessHeaders(reqClone);
        return next
            .handle(reqClone)
            .pipe(
                catchError(err => this.handleError(err))
                )
            .finally(() => {
                this.callCount--;
                if (this.callCount === 0) {
                    // this.spinnerService.RefreshspinnerMessage('');
                    this.spinnerService.hide();
                }
            });
    }

    handleError(response: HttpErrorResponse) {
        this.logDebug('Error occurred:', response.error);
        let errorMessage = 'Error occurred: Status:' + response.status;
        // this.toastError(errorMessage)
        if (isDevMode) {
            if (response.status !== 0) {
                if (response.error && response.error.Messages && response.error.Messages.length > 0) {
                    errorMessage += ' (' + response.error.Messages[0] + ') ';
                } else if (response.error) {
                    errorMessage += ' (' + response.error + ') ';
                }
            } else {
                errorMessage += ' (' + response.statusText + ') ';
            }
        } else {
            errorMessage += ' Please contact Tesla support.';
        }
        this.toastService.error(errorMessage);
        return throwError(response);
    }

    public setAccessHeaders(request: HttpRequest<any>): HttpRequest<any> {

        request =  this.DeleteRequestHeader(request, 'Authorization');
        request =  this.DeleteRequestHeader(request, 'X-PortalIdentity-UserName');
        request =  this.DeleteRequestHeader(request, 'X-RequestVerificationToken');
        request =  this.DeleteRequestHeader(request, 'X-XSRF-TOKEN');

        // if (request.headers.has('Authorization')) {
        //     request.headers.delete('Authorization');
        // }

        // if (request.headers.has('X-PortalIdentity-UserName')) {
        //     request.headers.delete('X-PortalIdentity-UserName');
        // }

        // if (request.headers.has('X-RequestVerificationToken')) {
        //     request.headers.delete('X-RequestVerificationToken');
        // }

        // if (request.headers.has('X-XSRF-TOKEN')) {
        //     request.headers.delete('X-XSRF-TOKEN');
        // }

        // if (!request.headers.has('content-type')) {
        //     request = request.clone({
        //         setHeaders: { 'content-type': 'application/json' },
        //     });
        // }

     /*   if (!!this.retrieve('access_token')) {
            // request.headers.append('Authorization', 'bearer ' + this.retrieve("access_token"));
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + this.retrieve('access_token'),
                },
            });
        } */
        // if (!!this.retrieve('UIContext_SupplierId')) {
        //     request = request.clone({
        //         setHeaders: {
        //             'UIContext_SupplierId' : this.retrieve('UIContext_SupplierId'),
        //         },
        //     });
        // }
        // if (!!this.retrieve('CurrentSupplierCode')) {
        //     request = request.clone({
        //         setHeaders: {
        //             Constants.localStorageKeys.CurrentSupplierCode : this.retrieve(Constants.localStorageKeys.CurrentSupplierCode),
        //         },
        //     });
        // }
        request = this.SetHeaderFromLocalStorage(request, Constants.localStorageKeys.IdToken);
        request = this.SetHeaderFromLocalStorage(request, Constants.localStorageKeys.CurrentSupplierCode);
        request = this.SetHeaderFromLocalStorage(request, Constants.localStorageKeys.CorrelationId);
        request = this.SetHeaderFromLocalStorage(request, Constants.localStorageKeys.XPortalIdentityUserName, 'X-PortalIdentity-UserName');

        // if (!!this.retrieve('ssUsername')) {
        //     //request.headers.append('X-PortalIdentity-UserName', this.retrieve("ssUsername"));
        //     request = request.clone({
        //         setHeaders: {
        //             'X-PortalIdentity-UserName': this.retrieve('ssUsername'),
        //         },
        //     });
        // }

        if (!!this.retrieve('ssCSRFToken')) {
            // request.headers.append('X-RequestVerificationToken', this.retrieve("ssCSRFToken"));
            request = request.clone({
                setHeaders: {
                    'X-RequestVerificationToken': this.retrieve('ssCSRFToken'),
                },
            });
        }

        if (!!this.getXsrfCookie()) {
            // request.headers.append('X-XSRF-TOKEN',this.getXsrfCookie());
            request = request.clone({
                setHeaders: { 'X-XSRF-TOKEN': this.getXsrfCookie() },
            });
        }

        // if (request.responseType === 'blob')
        //     request = request.clone({
        //         setHeaders: { Accept: 'application/pdf' },
        //     });
        return request;
    }

    private DeleteRequestHeader(request: HttpRequest<any>, headerName: string) {
        if (request.headers.has(headerName)) {
            request.headers.delete(headerName);
        }
        return request;
    }

    private SetHeaderFromLocalStorage(request: HttpRequest<any>, key: string, customHeaderName?: string) {
        let headerName = '';
        if (customHeaderName) {
            headerName = customHeaderName;
        } else {
            headerName = Constants.localStorageKeys[key];
        }
        const headerValue = this.retrieve(headerName);
        if (!!this.retrieve(headerName)) {
            request = request.clone({
                headers: request.headers.set(headerName, headerValue)
              });
        }
        return request;
    }

    private getXsrfCookie(): string {
        const cookies = document.cookie.split(';');
        for (let idx = 0; idx < cookies.length; idx++) {
            const matches = cookies[idx].match(
                /\b__RequestVerificationToken_.*=([^\s;]+)/
            );
            if (matches) {
                try {
                    return decodeURIComponent(matches[1]);
                } catch (decodeError) {
                    return '';
                }
            }
        }

        return '';
    }

    private retrieve(key: string): any {
        const item = localStorage.getItem(key);
        if (item && item !== 'undefined') {
            return JSON.parse(localStorage.getItem(key));
        }

        return;
    }
}
